import { AzureAdAccountModel } from "src/app/domain/models/azure-ad/account.model";

export class AddAzureAccount {
    static readonly type = '[AZURE ACCOUNT] Add';
    constructor(public payload: AzureAdAccountModel) { }
}
